import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function useLangPath() {
  const { lang } = useParams();
  const { i18n } = useTranslation();
  const activeLang = lang || i18n.language || 'en';
  return (path) => `/${activeLang}${path}`;
}
